import useBreakpoints from "~/hooks/useBreakpoints";

type Props = React.PropsWithChildren<{
  isActive: boolean;
}>;

export const MenuCategories: React.FC<Props> = ({ isActive, children }) => (
  <Menu
    className="md:right-[-13rem] md:p-2.5 md:before:right-[13.5rem] md:after:right-[13.5rem]"
    isActive={isActive}
  >
    <ul className="flex h-full flex-col gap-5 overflow-scroll pb-[170px] md:block md:min-w-[37.5rem] md:columns-[3_191px] md:gap-3 md:overflow-hidden md:pb-0">
      {children}
    </ul>
  </Menu>
);

export const MenuIndustries: React.FC<Props> = ({ isActive, children }) => (
  <Menu
    className="md:right-[-4.5rem] md:before:right-[5rem] md:after:right-[5rem]"
    isActive={isActive}
  >
    <ul className="flex h-full flex-col gap-4 overflow-scroll md:min-w-[150px] md:gap-0 md:overflow-hidden md:pb-0">
      {children}
    </ul>
  </Menu>
);

export const MenuCuts: React.FC<Props> = ({ isActive, children }) => (
  <Menu
    className="md:right-[-4.5rem] md:before:right-[5rem] md:after:right-[5rem]"
    isActive={isActive}
  >
    <ul className="flex h-full flex-col gap-4 overflow-scroll md:min-w-[150px] md:gap-0 md:overflow-hidden md:pb-0">
      {children}
    </ul>
  </Menu>
);

export const MenuBrands: React.FC<Props> = ({ isActive, children }) => (
  <Menu
    className="ml-[-0.75rem] mr-[-0.75rem] md:right-[-8rem] md:mx-0 md:!p-1 md:before:right-[8.5rem] md:after:right-[8.5rem]"
    isActive={isActive}
  >
    <ul
      data-testid="brandsList"
      className="mt-[-1rem] flex h-full w-full grow flex-row flex-wrap content-start gap-1.5 overflow-scroll md:mt-0 md:flex md:w-[39rem] md:flex-grow md:justify-center md:gap-0 md:overflow-hidden md:pb-0"
    >
      {children}
    </ul>
  </Menu>
);

const Menu: React.FC<
  React.PropsWithChildren<{
    isActive?: boolean;
    className?: string;
  }>
> = ({ isActive, children, className }) => {
  const { isDesktop } = useBreakpoints();
  return (
    <div
      role="nav"
      aria-label="secondary navigation"
      aria-hidden={!isDesktop && !isActive}
      className={`${
        isDesktop || isActive ? `block` : `hidden`
      } mt-2 h-full md:absolute md:top-8 md:mt-0 md:hidden md:h-auto md:border md:border-black md:bg-white md:p-2 md:before:absolute md:before:top-[-91px] md:before:mt-[73px] md:before:border-[12px] md:before:border-b-[6px] md:before:border-solid md:before:border-[transparent_transparent_#494949_transparent] md:before:content-[''] md:after:absolute md:after:top-[-92px] md:after:mt-[75px] md:after:border-[12px] md:after:border-b-[6px] md:after:border-solid md:after:border-[transparent_transparent_white_transparent] md:after:content-[''] md:group-hover/nav-item:flex ${className}`}
    >
      {children}
    </div>
  );
};
